export default __webpack_public_path__ + "ed05938f0455be4d84de2c2c437914ad.png";